import React, { useEffect, useState } from "react";
import api from "../../api/axios";
import PrintTagModal from "./PrintTagModal";

const styles = {
  backdrop: {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,0.45)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 900,
  },

  modal: {
    background: "#fff",
    width: "900px",
    maxHeight: "90vh",
    overflowY: "auto",
    borderRadius: "8px",
    padding: "24px",
    zIndex: 900,
  },

  infoGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "12px",
    marginBottom: "16px",
  },

  section: {
    marginBottom: "16px",
  },

  actions: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "12px",
    marginBottom: "16px",
  },

  submitBtn: {
    background: "#2563eb",
    color: "#fff",
    border: "none",
    padding: "10px 18px",
    borderRadius: "6px",
    cursor: "pointer",
  },

  closeBtn: {
    background: "#e5e7eb",
    border: "none",
    padding: "10px 18px",
    borderRadius: "6px",
    cursor: "pointer",
  },

 card: {
    border: "1px solid #e5e7eb",
    borderRadius: "6px",
    padding: "10px",
    marginBottom: "10px",
    background: "#fff",
  },
  header: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    fontSize: "14px",
  },
  avatar: {
    background: "#22c55e",
    color: "#fff",
    borderRadius: "50%",
    width: "26px",
    height: "26px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "14px",
  },
  username: {
    fontWeight: "600",
    color: "#2563eb",
  },
  badge: {
    background: "#2563eb",
    color: "#fff",
    padding: "2px 6px",
    borderRadius: "4px",
    fontSize: "12px",
  },
  time: {
    marginLeft: "auto",
    fontSize: "12px",
    color: "#6b7280",
  },
  comment: {
    marginTop: "6px",
    paddingLeft: "34px",
    color: "#374151",
  },
};

const MaintenanceDetail = ({ maintenanceId, onClose }) => {
  const [data, setData] = useState(null);
  const [status, setStatus] = useState("");
  const [comment, setComment] = useState("");
  const [showPrint, setShowPrint] = useState(false);

  useEffect(() => {
    if (maintenanceId) {
      api.get(`companyblog/admin/detail/${maintenanceId}/`).then((res) => {
        setData(res.data);
        setStatus(res.data.status);
      });
    }
  }, [maintenanceId]);

  const updateStatus = async () => {
    try {
      await api.post(`companyblog/admin/change-status/${maintenanceId}/`, {
        status,
        comment,
      });
      alert("Status updated successfully");
      onClose();
    } catch (err) {
      console.error(err);
      alert("Failed to update status");
    }
  };

  if (!data) return null;

  return (
    <>
    <div style={styles.backdrop}>
      <div style={styles.modal}>
        <h3>Maintenance Details</h3>
        <button className="btn btn-success d-flex align-items-center gap-1" onClick={() => setShowPrint(true)}>
        <i className="bi bi-printer"></i> Print Tag</button>

        {/* Basic Info */}
        <div style={styles.infoGrid}>
          <Info label="Customer" value={data.customer_name} />
          <Info label="Contact" value={data.customer_contact} />
          <Info label="Address" value={data.customer_address} />
          <Info label="Equipment" value={data.equipment_name} />
          <Info label="Problem" value={data.problems} />
        </div>

        {/* Status Update */}
        <div style={styles.section}>
          <label>Status</label>
          <select
            value={status}
            onChange={(e) => setStatus(e.target.value)}
          >
            <option>Pending</option>
            <option>Parts Pending</option>
            <option>Warranty</option>
            <option>Resolved Problem</option>
            <option>Unable To Repair</option>
            <option>Delivered</option>
          </select>

          <textarea
            placeholder="Comment (optional)"
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            rows={3}
          />
        </div>

        <div style={styles.actions}>
          <button style={styles.submitBtn} onClick={updateStatus}>
            Submit
          </button>
          <button style={styles.closeBtn} onClick={onClose}>
            Close
          </button>
        </div>

        <h4>Timeline</h4>
          {data.timeline.map((t) => (
            <div key={t.id} style={styles.card}>
              <div style={styles.header}>
                <span style={styles.avatar}>👤</span>
                <span style={styles.username}><b>Record Created by:</b> {t.created_by}</span>

                {t.action.includes("Status changed") && (
                  <span style={styles.badge}>
                    {t.action.replace("Status changed to ", "")}
                  </span>
                )}

                <span style={styles.time}>
                  {new Date(t.created_at).toLocaleTimeString()}
                </span>
              </div>

              {t.comment && (
                <div style={styles.comment}>
                  {t.comment}
                </div>
              )}
            </div>
          ))}

      </div>
    </div>
    <PrintTagModal show={showPrint}onClose={() => setShowPrint(false)}recordId={data?.id}/>
</>
  );
};

const Info = ({ label, value }) => (
  <div>
    <strong>{label}:</strong>
    <div>{value || "—"}</div>
  </div>
);

export default MaintenanceDetail;
